import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './services/auth.guard';
import { Role } from './data/role';

const routes: Routes = [
  {
    path: '', 
    component: FullComponent, 
    canActivate: [AuthGuard],
    data: {
          roles: [
            Role.Administrador,
            Role.Kardex,
            Role.JefaturaKardex,
            Role.Sistemas,
            Role.Contabilidad,
            Role.MesaDefuncion,
            // Role.Secretaria,
            Role.AuxiliarPresidencia,
            Role.Caja,
            Role.Archivo,
            Role.Legal,
            Role.MesaDefuncion,
            Role.MesaTestamentacion,
            Role.AuxiliarTesoreria
          ],
        },
    children: [
      { path: '', loadChildren: () => import('./pages/sdm/sdm.module').then((m) => m.SDMModule) },
    ],  
  },
  {
    path: '', component: BlankComponent, children: [
      { path: 'authentication', loadChildren: () => import('./pages/authentication/authentication.module').then((m) => m.AuthenticationModule) },
      {
        path: 'registro-sede',
        loadComponent: () =>
          import('./modules/citas/gestion/registro-sede/registro-sede.component').then(
            (m) => m.RegistroSedeComponent,
          ),
      },
      {
        path: 'lobby-sede',
        loadComponent: () =>
          import('./modules/citas/gestion/lobby-sede/lobby-sede.component').then(
            (m) => m.LobbySedeComponent,
          ),
      },
    ],
  },
  { path: 'visualizador-archivo', loadChildren: () => import('./pdf-viewer/pdf-viewer.module').then(m => m.PdfViewerModule) },
  {
    path: '**',
    redirectTo: 'authentication/error',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
